import React from 'react';
import { SVFViewer } from '~components/atoms/Viewers/SVFViewer/SVFViewer';
import { useFileViewerContext } from '~src/contexts/FileToViewContext';

// Fullscreen overlay that shows the PRIMARY preview model (3D shortcut)
// Triggered via setPrimaryPreviewFile(...) instead of setFileToView(...)

export const PrimaryViewerPreviewWrapper: React.FC = () => {
  const { primaryPreviewFile, setPrimaryPreviewFile } = useFileViewerContext();

  if (!primaryPreviewFile) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: '#000',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
      }}>
      <SVFViewer
        fileToView={primaryPreviewFile as any}
        onClose={() => setPrimaryPreviewFile(undefined)}
        showTitle={true}
      />
    </div>
  );
};
